const initialState: PromoCodeState = {
  name: null,
  description: null,
  trialDays: null,
  valid: false,
};

export default function promoCodeReducer(
  state = initialState,
  action: PromoCodeAction
) {
  switch (action.type) {
    case "UPDATE_PROMO_CODE":
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}
